// extracted by mini-css-extract-plugin
module.exports = {"similar":"_66813664"};